import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import { InhouseGameDetails } from 'config/types/game'
import { GameInHouseConfig } from 'views/InhouseGame/config/types'
import DiceGameResult from './components/DiceGameResult'
import DiceResultHistory from './components/DiceResultHistory'
import DiceGameTargetConfig from './components/DiceGameConfig'
import { DiceGameTargetType } from '../../config'
import { useDiceGameStatus } from '../../hooks'

const GameBoard: React.FC<
  {
    disabled?: boolean
    game: InhouseGameDetails
    target: string
    onTargetChanged: (value: string) => void
    targetType: DiceGameTargetType
    setTargetType: (value: DiceGameTargetType) => void
  } & GameInHouseConfig &
    BoxProps
> = ({ onTargetChanged, target, targetType, setTargetType, disabled, volumeEnable, game, ...props }) => {
  const { isPlaying } = useDiceGameStatus()
  const isDisabledConfig = isPlaying || disabled

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      width="100%"
      overflow="hidden"
      height={['100%', '', '', '', '570px', '616px', '95%']}
      p={['12px', '', '12px 20px']}
      {...props}
    >
      <DiceResultHistory game={game} />
      <DiceGameResult
        volumeEnable={volumeEnable}
        target={target}
        disabled={isDisabledConfig}
        setTarget={onTargetChanged}
        targetType={targetType}
      />
      <DiceGameTargetConfig
        target={target}
        disabled={isDisabledConfig}
        onTargetChanged={onTargetChanged}
        targetType={targetType}
        setTargetType={setTargetType}
      />
    </Flex>
  )
}

export default GameBoard
